import { useGoogleLogin } from '@react-oauth/google';
import * as React from 'react';
import { useLogin } from 'src/hooks/api/fetchApi';
import Button from '../molecules/Button';

interface IProps {
  loading?: boolean;
}

const LoginButton: React.FC<IProps> = ({ loading }) => {
  const login = useLogin();
  // Covers the gap after Google's popup closes: the token exchange (Google + Odoo
  // lookups on the server) and the /me refetch that follows it.
  const [signingIn, setSigningIn] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const handleLogin = useGoogleLogin({
    onSuccess: async tokenResponse => {
      setSigningIn(true);
      setError(null);
      try {
        await login(tokenResponse.access_token);
      } catch (e) {
        setError(e instanceof Error ? e.message : 'Sign-in failed');
      } finally {
        setSigningIn(false);
      }
    },
    // Google refused (e.g. consent denied); closing the popup is not an error.
    onError: response => setError(response.error_description ?? 'Google sign-in failed'),
  });

  const busy = loading || signingIn;

  return (
    <>
      <Button onClick={() => handleLogin()} loading={busy} disabled={busy}>
        Sign in with Google
      </Button>
      {error && (
        <p className="login-error" role="alert">
          {error}
        </p>
      )}
    </>
  );
};

export default LoginButton;
